/**
 * useGamifEvents · Temporada 1
 *
 * No hay push en vivo desde el backend para nivel/badges (solo se pide el
 * perfil al montar GamifWidget/RachaBanner). Este hook llena ese hueco sin
 * tocar el backend: pide el perfil cada POLL_MS, lo compara contra el último
 * snapshot guardado en localStorage, y dispara "gamif:level-up" /
 * "gamif:badge-earned" cuando detecta un cambio real — mismo patrón que ya
 * usa "gamif:xp-gain" en api/client.js.
 *
 * La primera corrida de cada usuario solo guarda la base (no dispara nada),
 * así no explota un "subiste de nivel" falso para todo el equipo el día que
 * esto se despliega (justo después del reset de Temporada 1).
 */
import { useEffect, useRef } from "react";
import { api } from "../api/client.js";

const LS_PREFIX = "gamif:last-snapshot:";
const POLL_MS = 3 * 60 * 1000;

export function useGamifEvents(userId) {
  const timerRef = useRef(null);

  useEffect(() => {
    if (!userId) return;
    const key = LS_PREFIX + userId;

    const check = async () => {
      let profile;
      try { profile = await api.getGamifProfile(userId); }
      catch { return; }
      if (!profile?.nivel) return;

      let prev = null;
      try { prev = JSON.parse(localStorage.getItem(key) || "null"); } catch {}

      const nivelActual = profile.nivel.nivel;
      const badgeIds = (profile.badges || []).map(b => `${b.badge_id}:${b.tier}`);

      if (prev) {
        if (nivelActual > prev.nivel) {
          window.dispatchEvent(new CustomEvent("gamif:level-up", { detail: { nivel: profile.nivel } }));
        }
        const nuevos = badgeIds.filter(id => !prev.badgeIds.includes(id));
        for (const id of nuevos) {
          const badge = (profile.badges || []).find(b => `${b.badge_id}:${b.tier}` === id);
          if (badge) window.dispatchEvent(new CustomEvent("gamif:badge-earned", { detail: { badge } }));
        }
      }

      try { localStorage.setItem(key, JSON.stringify({ nivel: nivelActual, badgeIds })); } catch {}
    };

    check();
    timerRef.current = setInterval(check, POLL_MS);
    return () => clearInterval(timerRef.current);
  }, [userId]);
}
